import styled from 'styled-components';

const ButtonContainer = styled.div`
  position: absolute;
  display: flex;
  height: 38px;
  width: 38px;
  justify-content: center;
  align-items: center;
  top: 50%;
  transform: translate(-50%, -50%);
  ${props => (props.left ? `left: 0%` : `right: 0%`)};
  z-index: 2;
`;

export default ButtonContainer;
